module.exports = __webpack_public_path__ + "img/2.c1eb9d1a.jpg";